<!--
 * @Author: 盛东 543487299@qq.com
 * @Date: 2023-10-11 10:22:05
 * @LastEditors: 盛东 543487299@qq.com
 * @LastEditTime: 2023-10-23 18:15:30
 * @FilePath: \girdear_mall_web\src\views\pms\purchaseSku\components\SkuWeight.vue
 * @Description: 这是默认设置,请设置`customMade`, 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
-->
<template>
  <div>
    <el-dialog
      width="800px"
      title="选择单品"
      :before-close="handleClose"
      :visible.sync="Open"
      :close-on-click-modal="false"
    >
      <BaseTable ref="baseTable" :fn-init="Fninit" :table="table" />

      <span slot="footer" class="dialog-footer">
        <el-button @click="handleClose">取消</el-button>
        <el-button
          :loading="loadingButton"
          type="primary"
          @click="dialogConfirm()"
        >
          确定
        </el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
  import { productSkuChoosePageList } from '@/api/goods/productSku'
  import { defaultSearchOptions } from './config'
  import { productCategoryTreeList } from '@/api/goods/productCategory.js'
  export default {
    components: {},
    props: {
      selectData: {
        type: Array,
        default: () => {
          return []
        },
      },
      row: {
        type: Object,
        default: () => {
          return {}
        },
      },
    },
    data() {
      return {
        openSelectSku: false,
        loadingButton: false,
        Open: true,
        table: {
          name: '',
          defaultParams: {
            deptIdList: undefined,
            skuType: 1,
          },
          showSearchBar: true,
          searchOptions: JSON.parse(JSON.stringify(defaultSearchOptions)),
          canRefresh: false, // 刷新按钮
          showMoreBtns: false, // 展示新增按钮
          border: true,
          selection: true,
          moreBtns: [],
          selectData: [],
          selectName: 'skuId', // 禁用的时候唯一标识
          dictKey: [
            {
              type: 'skuType',
              source: 'ENUM',
            },
          ],
          // 草稿 tempStorage  1 2
          options: [
            {
              label: '货品类型',
              key: 'skuType',
              type: 'dict',
              dictKey: 'skuType',
              visible: true,
              align: 'center',
            },
            {
              label: '单品编码',
              key: 'skuSn',
              align: 'center',
              type: 'name',
              visible: true,
            },
            {
              label: '单品名称',
              key: 'skuName',
              align: 'center',
              type: 'name',
              visible: true,
            },
            {
              label: '货品分类',
              key: 'categoryFullName',
              type: 'name',
              align: 'center',
              visible: true,
            },
          ],
        },

        Fninit: () => {
          return {
            initData(params) {
              return new Promise((resolve) => {
                productSkuChoosePageList(
                  this.objectSavekey(params),
                  this.objectDelkey(params)
                ).then((res) => {
                  resolve(res)
                })
              })
            },

            clearOptions() {
              // 重置清空搜索框
              this.table.defaultParams = {}
              this.table.searchOptions = JSON.parse(
                JSON.stringify(defaultSearchOptions)
              )
            },
          }
        },
        form: {},
      }
    },
    created() {
      this.getproductCategoryTreeList()
      this.table.selectData = this.selectData
    },
    methods: {
      getproductCategoryTreeList() {
        productCategoryTreeList({
          categoryStatus: 1,
        }).then((res) => {
          defaultSearchOptions[2].options = res.data
          this.table.searchOptions[2].options = res.data
        })
      },
      handleRemove(index) {
        this.$confirm('确定删除？删除后无法恢复', '删除', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning',
        })
          .then(() => {
            this.form.skus.splice(index, 1)
          })
          .catch(() => {})
      },
      handleSkuOpen() {
        this.openSelectSku = true
      },
      dialogConfirm() {
        this.$emit('getSelect', 1, this.$refs.baseTable.multipleSelection)
      },
      handleClose() {
        this.$emit('getSelect')
      },
    },
  }
</script>
<style lang="scss" scoped></style>
